import i18next from 'i18next';

import { getItems } from 'common/api/funnelProposals';
import alerts from 'common/modules/alerts';
import { formatDate, parseDate } from 'common/utils/dates';

import {
    FETCH_ITEMS,
    FETCH_ITEMS_FAILURE,
    FETCH_ITEMS_SUCCESS,
} from '../actionTypes';
import { PER_PAGE } from '../constants';
import { actions } from '../reducer';

export default (filterQuery) => (dispatch) => {
    dispatch(actions[FETCH_ITEMS]());

    const newFilterQuery = {
        company: filterQuery.company,
        executive: filterQuery.executive,
        range: `${formatDate(
            parseDate(filterQuery.initial_date, 'dd/MM/yyyy'),
            'yyyy-MM-dd',
        )},${formatDate(
            parseDate(filterQuery.final_date, 'dd/MM/yyyy'),
            'yyyy-MM-dd',
        )}`,
        search: filterQuery.search,
    };

    getItems({ filterQuery: newFilterQuery, perPage: PER_PAGE })
        .then((response) => {
            let index = 0;
            const data = response.data.data.reduce(
                (accColumns, { has_next_page, id, name, proposals }) => {
                    const value = {
                        ...accColumns,
                        [id]: {
                            hasNextPage: has_next_page,
                            id,
                            index,
                            name,
                            projects: proposals,
                        },
                    };
                    index++;
                    return value;
                },
                {},
            );

            dispatch(
                actions[FETCH_ITEMS_SUCCESS]({
                    funnelProjects: data,
                    filterQuery,
                }),
            );
        })
        .catch((error) => {
            if (error.response.data && error.response.data?.errors?.length) {
                const dataAlert = {
                    title: i18next.t('Message'),
                    messages: error.response.data.errors,
                    type: alerts.ALERT_TYPE_ALERT,
                    variant: 'warning',
                };

                dispatch(alerts.actions.show(dataAlert));
            }
            dispatch(actions[FETCH_ITEMS_FAILURE](error));
        });
};
